import React, { Component } from 'react';
import './Result.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import MapComponent from './MapComponent/MapComponent';
import PrioritiesComponent from './PrioritiesComponent/PrioritiesComponent';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ReactToPrint from "react-to-print";

class Result extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            current: [],
            future: []
        };
    }

    componentWillMount() {
        // let body = {
        //     projectId: this.props.projectId,
        //     type: 'influencerMap'
        // }
        // this.props.getInfluencerMapGroups(body);
        //  debugger
    }

    componentWillReceiveProps(nextProps) {

        if (this.props.addInfluencerMapGroupsData !== nextProps.addInfluencerMapGroupsData) {
            let body = {
                projectId: this.props.projectId,
                type: 'influencerMap'
            }
            this.props.getInfluencerMapGroups(body);

        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    craetePrioritiesArr = (type, value) => {
        this.state[type].push(value);
    }

    downloadPDF = () => {
        let print = document.getElementById('print');
        html2canvas(print)
            .then((canvas) => {
                let wid
                let hgt
                const imgData = canvas.toDataURL('image/png', wid = canvas.width, hgt = canvas.height);
                let hratio = hgt/wid
                let pdf = new jsPDF('p','pt','a4');
                let width = pdf.internal.pageSize.width;
                let height = width * hratio
                pdf.addImage(imgData,'JPEG',0,0, width, height);
                pdf.save('pricing-value.pdf');
            });
    };

    render() {
        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-six arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-six arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 5</p>
                    </div>
                    <div className='step step-six arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-lg-7">
                        <h5>Influencer Map</h5>
                      </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className='card' id="print" ref={el => (this.componentRef = el)}>
                                <div className='card-header'>
                                    <h5>Results</h5>
                                </div>
                                <div className='card-body' >
                                    <div className='row'>

                                        {this.props.getInfluencerMapGroupsData.Items[0].priorities &&
                                            <PrioritiesComponent
                                                getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                            />
                                        }

                                        {/* <div className='col-sm-7'  style={{overflow: "scroll"}}> */}
                                        <div className="canvas-card" style={{overflow: "scroll", width: '100%'}}>
                                            <div className='canvas-content' id="banner-contenedor">
                                                {!_.isEmpty(this.props.getInfluencerMapGroupsData) &&
                                                    <MapComponent
                                                        getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <Link className='btn btn-success' to={'/benefits-ladder/'+this.props.projectId}> Next </Link>
                                    <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                    <div className='btn empty-btn default' onClick={this.downloadPDF}>Save PDF</div>
                                    <ReactToPrint
                                        trigger={() => <a className='btn empty-btn default' href="#">Print</a>}
                                        content={() => this.componentRef}
                                    />
                                    <div className='btn empty-btn default' onClick={this.props.groupStateBack}>Back</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (Result);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/Result/Result.jsx